module.exports = __webpack_public_path__ + "static/media/header_login.a02eb673.png";